/**
 * Onboarding Tour Config
 *
 * Product tour steps consumed by the discoverability provider.
 *
 * Primary responsibilities:
 * - Define stable onboarding targets for the chat surface
 * - Keep step copy and selectors close to the tour runtime
 *
 * Dependencies:
 * - Onborda step types
 */

import type { Tour } from 'onborda'

export const tourConfig = [
  {
    tour: 'main',
    steps: [
      {
        icon: null,
        title: 'Start from the composer',
        content: 'Ask Losi to draft, search, summarize, or work with the context already open.',
        selector: '#chat-input',
        side: 'top' as const,
        showControls: true,
        pointerPadding: 10,
        pointerRadius: 10
      },
      {
        icon: null,
        title: 'Write naturally',
        content:
          'Use plain language and add files, links, or workspace context when the task needs more detail.',
        selector: '#chat-input',
        side: 'top' as const,
        showControls: true,
        pointerPadding: 10,
        pointerRadius: 10
      },
      {
        icon: null,
        title: 'Tune the model',
        content:
          'Switch models and reasoning settings when you need a faster answer or a deeper pass.',
        selector: '#chat-input',
        side: 'bottom' as const,
        showControls: true,
        pointerPadding: 10,
        pointerRadius: 10
      },
      {
        icon: null,
        title: 'Reuse useful answers',
        content:
          'Copy, edit, retry, share, or save important responses from the message action row.',
        selector: '#chat-input',
        side: 'top' as const,
        showControls: true,
        pointerPadding: 10,
        pointerRadius: 10
      }
    ]
  }
] satisfies Tour[]
